const RequestCsiaction = async (input, filtermessages, userId, mode,loginInfo,setMessages) => {
//ApiHandler.search              (newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)

    const filter = loginInfo.faqapi.csiaction.filter
    //const filter = "(category eq 'RAG-TRK-S')"
    //const filter = "(category eq 'action')or(category eq 'RAG-TRK-S')"
    //(group eq 'ServicePortal' ) and (category eq 'action')or (category eq 'RAG-TRK-S')
    let prompt
    
    if (loginInfo?.prompt?.csiaction?.prompt){
        prompt=loginInfo.prompt.csiaction.prompt
    }else{
        prompt=`あなたはマニュアルに対して質問に答えるRAGアシスタントです。
#ルール:
- ユーザーの【質問】に対して【テキスト】【過去履歴】を参考にして回答してください。
- 【過去の履歴】からユーザーの意図を理解してください。
- 【テキスト】【過去履歴】にないことは答えないでください。
- わかりやすく手順を箇条書きにしてください。`
    }

//直近のメッセージボットの1つ取得
    filtermessages.shift();
    const histmessages = filtermessages.slice(-1);

    const repInput = histmessages
    .filter(msg => msg.sender === "user") // userのメッセージだけに絞る
    .map((msg, index) => {
        // テキストからHTMLタグを除去
        const cleanText = msg.text.replace(/<[^>]*>|\[画像情報\]/g, '');
        // filename がある場合は filename + text を結合
        const combinedText = msg.imagemessage
        ? `${msg.imagemessage} ${cleanText}`
        : cleanText;
        const numberedText = `${combinedText}`;

        return { content: numberedText };
    });


    const query = {
        search: repInput[0].content,
        top: 5,
        filter: '',
        select: "sub_category,category,title,content,answer,text,site_name,URL,site_icon,model,update_at,tag",
        vectorQueries: [
            { 
                kind: "text",
                text: repInput[0].content,
                k: 5,
                fields: "embedding"
            }
        ],
    queryType: "semantic",
    captions: "extractive",
    answers: "extractive|count-3",
    semanticConfiguration: "cosmosdb03-semantic-configuration",
    queryLanguage: "ja-JP"
    }


//    queryType: "semantic",
//    captions: "extractive",
//    answers: "extractive|count-3",
//    semanticConfiguration: "cosmosdb03-semantic-configuration",
//    queryLanguage: "ja-JP"

    const header = {
        'Content-Type': 'application/json',
        'api-key': "XXXXX",
    };

    const requestBody = {
        api:process.env.REACT_APP_FAQ_URL,
        header:header,
        query: query,
        filter:filter,
        userId: userId,
        mode:mode,
        prompt:prompt,
        inputs:repInput[0].content
    };

    try {

        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let resmessage = "";

        while (true) {

            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop();

            for (let line of lines) {
            line = line.trim();
            if (!line.startsWith("data:")) continue;
            const jsonStr = line.replace(/^data:\s*/, "");
            
            if (jsonStr === "[DONE]") continue;

            try {
                const dataObj = JSON.parse(jsonStr);
                const delta = dataObj.choices[0].delta.content;
                resmessage += delta; // ここで逐次 finalText に追加
                if (delta) {
                setMessages((prev) => {
                    const newMessages = [...prev];
                    if (newMessages.length === 0 || newMessages[newMessages.length - 1].sender !== "csiaction"
                    ) { 
                        newMessages.push({ id: crypto.randomUUID(),sender: "csiaction", text: delta , mode: 'csiaction', timestamp: Date.now()});
                    } else {
                        newMessages[newMessages.length - 1].text += delta;
                    }
                    return newMessages;
                });
                }
            } catch (e) {
                console.error("JSON parse error:", e, jsonStr);
            }
            }
        }

        return resmessage

    } catch (error) {
        console.log('API_応答データerror:', error);
        return `申し訳ありません。<br>問合せエラーが発生しました。`
    }

};

// 🔹 他のファイルで使えるようにエクスポート
export default RequestCsiaction;
